module.exports = {
      id: "leo-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#leo",
      toString: function () {
        return this.url;
      }
    }